import React from 'react';
import './ActionBar.scss';
import { MdDelete } from 'react-icons/md';
import assignimg from '../../assets/images/assignimg.png'
import labelsimg from '../../assets/images/labelsnotactive.svg'
import impexpimg from '../../assets/images/importexportimg.png'
import notesimg from '../../assets/images/notesnotactive.svg'

export default function ActionBar({ allSelected, toggleAll }) {
  return (
    <div className="action-bar">
      <input type="checkbox" checked={allSelected} onChange={toggleAll} />
      <button><MdDelete  className='actionbar-icons' color='#686868'/></button>
      <button><img src={assignimg} alt='assignimg' className='actionbar-icons'/></button>
      <button><img src={labelsimg} alt='labelsimg' className='actionbar-icons'/></button>
      <button><img src={impexpimg} alt='impexpimg' className='actionbar-icons'/></button>
      <button><img src={notesimg} alt='notesimg' className='actionbar-icons'/></button>
    </div>
  );
}
